import OneSignal from "react-onesignal";
import { api } from "@/lib/api";

let initPromise = null;

// Android WebView bridge: React Native WebView or Kotlin JavascriptInterface "UKerjaAndroid"
function native(action, payload = {}) {
  const msg = JSON.stringify({ source: "ukerja", action, ...payload });
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(msg);
    return true;
  }
  if (window.UKerjaAndroid?.postMessage) {
    window.UKerjaAndroid.postMessage(msg);
    return true;
  }
  return false;
}

export function initOneSignal(appId) {
  if (!appId) return Promise.resolve(false);
  if (!initPromise) {
    initPromise = OneSignal.init({
      appId,
      serviceWorkerPath: "push/onesignal/OneSignalSDKWorker.js",
      serviceWorkerParam: { scope: "/push/onesignal/" },
      autoResubscribe: true,
      allowLocalhostAsSecureOrigin: true,
    }).then(() => true).catch(() => { initPromise = null; return false; });
  }
  return initPromise;
}

function userTags(user) {
  const a = user.address || {};
  const tags = { role: user.is_worker ? "worker" : "user" };
  if (a.province) tags.province = a.province;
  if (a.regency) tags.regency = a.regency;
  return tags;
}

const isAndroid = () => /Android/i.test(navigator.userAgent);
const isAndroidWebView = () => isAndroid() && (/; wv\)/.test(navigator.userAgent) || !("Notification" in window));

function serverLink() {
  const run = () => api.post("/push/link-device").then((r) => r.data?.linked).catch(() => false);
  run().then((ok) => { if (!ok) setTimeout(run, 20000); });
}

export async function linkUser(appId, user) {
  if (native("onesignal-login", { externalId: String(user.id), tags: userTags(user) })) return;
  if (isAndroid()) serverLink();
  if (isAndroidWebView()) return;
  if (!(await initOneSignal(appId))) return;
  try {
    await OneSignal.login(String(user.id));
    await OneSignal.User.addTags(userTags(user));
  } catch (e) {
    // push is optional; ignore SDK errors
  }
}

export async function requestPush(appId) {
  if (native("onesignal-permission")) return;
  if (!(await initOneSignal(appId))) return;
  try {
    await OneSignal.Notifications.requestPermission();
  } catch (e) {
    // ignore
  }
}

export async function unlinkUser() {
  if (native("onesignal-logout")) return;
  if (!initPromise) return;
  try {
    await OneSignal.logout();
  } catch (e) {
    // ignore
  }
}
